import type { CXRootStore } from '../stores/cx-root.store';
import { ISubmitCodeResponse } from '~/components/ClientExperience/types/server.types';
import { IRecaptchaTokenData } from '~/common/hooks/useHBGoogleReCaptcha';

export interface ISendLoginLinkProps extends IRecaptchaTokenData {
    flowId: string;
    userEmail?: string;
    userId?: string;
}

export interface ISubmitVerificationCodeProps {
    code: string;
    userEmail?: string;
    userId?: string;
    flowId?: string;
    fToken: string;
    fingerprint: string;
}

export class UserCXCtrl {
    rootStore: CXRootStore;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    async sendVerificationCodeEmail(sendLoginLinkProps: ISendLoginLinkProps) {
        const { userService, configStore, userStore } = this.rootStore;

        return userService.sendVerificationCodeEmail({
            ...sendLoginLinkProps,
            activate_recaptcha: configStore.config.activate_recaptcha,
            fingerprint: userStore.fingerprint
        });
    }

    async submitVerificationCode(
        params: ISubmitVerificationCodeProps
    ): Promise<ISubmitCodeResponse> {
        const { userService } = this.rootStore;

        return userService.submitVerificationCode(params);
    }

    async validateEmail(email) {
        const { userService } = this.rootStore;

        return userService
            .validateEmail(email)
            .then(() => true)
            .catch(() => false);
    }

    // TODO: this should be in the user controller once we organize the cx/non cx depndencies
    async fetchUser(id: string) {
        const { userService, userStore } = this.rootStore;

        const user = await userService.fetchUser(id);

        userStore.update(user);

        return user;
    }
}
